import React, { useCallback } from 'react';

import { PageSegmentLoadEnd } from '@confluence/browser-metrics/entry-points/PageSegmentLoadEnd.ts';

import { useConnectAppsState } from './useConnectAppsState.ts';

export const ConnectAppsMeasure = ({ contentId, metric }) => {
	const [connectApps, connectAppsActions] = useConnectAppsState();

	// Reset state
	const onMeasureCompleted = useCallback(() => {
		connectAppsActions.resetConnectApps();
	}, [connectAppsActions]);

	if (!connectApps?.isReady) {
		return null;
	}

	// If all apps are loaded and data is empty, still need to reset state
	if (!connectApps?.data) {
		onMeasureCompleted();
		return null;
	}

	return (
		<PageSegmentLoadEnd
			key={contentId}
			metric={metric}
			customData={{
				connectApps: connectApps?.data,
			}}
			onComplete={onMeasureCompleted}
		/>
	);
};
